import { ModeloBase } from "./modeloBase"

export const ModeloSopInventoryGranularidade = {
  CODIGO: ["cod_familia_subgrupo_produto_capitao", "cod_linha_produto_capitao", "cod_produto_capitao", "cod_gerencia"],
  DESCRICAO: ["des_familia_subgrupo_produto_capitao", "des_linha_produto_capitao", "des_produto_capitao", "des_gerencia"],
  INTERFACE: ["Família Subgrupo", "Linha", "Capitão", "Regional"],
}

export class ModeloSopInventory extends ModeloBase {
  cod_tela_sop_inventory?: number;
  des_time?: string;
  cod_business_unit?: number;
  cod_industrial_plant?: number;
  cod_product?: number;

  num_fg_inventory_real_units?: number;
  num_fg_inventory_forecast_units?: number;
  num_fg_inventory_budget_units?: number;

  num_fg_inventory_real_usd?: number;
  num_fg_inventory_forecast_usd?: number;
  num_fg_inventory_budget_usd?: number;

  num_fg_inventory_unitcost_real?: number;
  num_fg_inventory_unitcost_forecast?: number;
  num_fg_inventory_unitcost_budget?: number;

  num_rm_inventory_real_usd?: number;
  num_wip_inventory_real_usd?: number;
  num_othersmro_inventory_real_usd?: number;

  num_total_inventory_real_usd?: number;
  num_total_unitcost_real_usd?: number;

  turn?: number;
  doh?: number;

  des_business_unit?: string;
  des_product_family?: string;
  des_product?: string;
  des_industrial_plant?: string;

}
